import { render, staticRenderFns } from "./UnitBulkCalendarRestriction.vue?vue&type=template&id=663674d0&scoped=true&"
import script from "./UnitBulkCalendarRestriction.vue?vue&type=script&lang=js&"
export * from "./UnitBulkCalendarRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663674d0",
  null
  
)

export default component.exports